// extracted by mini-css-extract-plugin
export default {"modalWrap":"ModalExit_modalWrap__vZiYr","modal":"ModalExit_modal__+rFpr","description":"ModalExit_description__TUqP2","title":"ModalExit_title__GjTJR"};